module.exports = __webpack_public_path__ + "img/bulb.1a88ddc2.svg";